/* eslint-disable max-len */
import * as React from 'react';
import { v4 } from 'uuid';

import { IListElement } from '@app/components/DropList/DropList';

const DAVID_NANKIN = `David Nankin has been the Vice President - Private Client Group at Stifel, Nicolaus since 2007. Mr. Nankin was Vice President at Ryan, Beck from 2005 until their acquisition by Stifel, Nicolaus in 2007. He started his investment career with Mosely, Hallgarten, Estabrook, and Weeden in 1976.
Mr. Nankin holds a BBA degree in Management from the University of Massachusetts.`;
const STEPHEN_RUDNER = 'Stephen A. Rudner is a Director of Online Vacation Center Holdings Corp. and also serves as the Company\'s President. Mr. Rudner has previously served as the Chief Financial Officer, Director of Information Technology, and Director of Sales of Online Vacation Center, Inc. Mr. Rudner joined the Company in November of 2011 as the Manager of Accounting. Prior to joining Online Vacation Center, Mr. Rudner worked as a senior auditor for Deloitte & Touche LLP. Mr. Rudner holds a Master of Science degree in Accounting from the University of Florida and is a Certified Public Accountant in the state of Florida.';
const DANIEL_RUDNER = 'Daniel J. Rudner is the Director of Recruiting for Expedia CruiseShipCenters, OVC. Mr. Rudner held various positions in Business Development, Air & Sea, and E-commerce at Norwegian Cruise Line and Costa Cruises from 2006 through 2013. From 2004 through 2006, Mr. Rudner worked part-time in the Accounting department of Online Vacation Center while he was a student at Florida Atlantic University. Mr. Rudner holds a Bachelor\'s Degree in Small Business Management and Entrepreneurship from Florida Atlantic University.';
const RICHARD_MCKINNON = (
	<>
		<p>
			Richard A. McKinnon is a director of Online Vacation Center Holdings Corp.
		</p>
		<p>
			During more than thirty years in the travel industry, Mr. McKinnon is most lauded for founding Vacation.com, the nation's largest vacation selling network whose member agencies sell more than $20 billion in leisure travel annually. Following the sale of Vacation.com to Amadeus, the leading global distribution system and technology provider for the world's travel and tourism industries, Mr. McKinnon was appointed CEO of Amadeus North America. Previously, Mr. McKinnon held senior positions in several major travel businesses including American Airlines, Pan American World Airways, Delta Air Lines, Wyndham Resort Hotels and US Air. He also served as president of American Hawaiian Cruises and the Delta Queen Steamboat Company.
		</p>
		<p>
			Since 2008, Mr. McKinnon has served as President of Management Recruiters International, a worldwide executive search firm. He also serves as a director for Tauck, Inc. and GSC Acquisition Company.
		</p>
		<p>
			Mr. McKinnon is a graduate of the United States Military Academy with a Bachelor of Science degree and has a Law degree from the Emory University School of Law. He currently resides in Dallas, Texas.
		</p>
	</>
);
const EDWARD_RUDNER = (
	<>
		<p>
			Edward B. Rudner is a Director of Online Vacation Center Holdings Corp. and also serves as its Chairman and CEO.
		</p>
		<p>
			Mr. Rudner has more than 30 years of experience in the travel industry. Previously, he served as the CFO and COO of Alamo-Rent-A-Car. Under his guidance, Alamo-Rent-A-Car increased its fleet size from 400 to 50,000 automobiles, and expanded from a Florida-based company into a national car rental agency. Following his tenure at Alamo, Mr. Rudner went on to become president and CEO of Certified Vacations, where he cultivated the business from 10,000 to 250,000 vacation packages per year. More recently, he served as the CEO of Renaissance Cruises where he expanded ship assets from $60 million to over $1 billion and increased revenues from $20 million to $500 million over a nine-year period until June of 2000.
		</p>
		<p>
			In October of 2000, Mr. Rudner founded Online Vacation Center, Inc., which today is one of the largest cruise sellers in the United States.
		</p>
		<p>
			Mr. Rudner graduated cum laude with a Bachelor of Arts degree in History from the University of Massachusetts and currently resides in Fort Lauderdale, Florida.
		</p>
	</>
);
export const directorsList: Array<IListElement> = [
	{
		title: 'David Nankin, Director',
		text: DAVID_NANKIN,
		id: v4(),
	},
	{
		title: 'Stephen A. Rudner, Director and President',
		text: STEPHEN_RUDNER,
		id: v4(),
	},
	{
		title: 'Daniel J. Rudner, Director',
		text: DANIEL_RUDNER,
		id: v4(),
	},
	{
		title: 'Richard A. McKinnon, Director',
		text: RICHARD_MCKINNON,
		id: v4(),
	},
	{
		title: 'Edward B. Rudner, Director, Chairman, and CEO',
		text: EDWARD_RUDNER,
		id: v4(),
	},
];
